import {ReactNode} from "react";
import OverlaySidebar from "../components/overlay/OverlaySidebar";
import {styled} from "@chakra-ui/react";

const Page = styled("div", {
  baseStyle: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
    height: "100vh",
    backgroundColor: "#FFFFFF",
  }
})

interface PageTemplateProps {
  children: ReactNode;
}

function PageTemplateMain({
  children
}: PageTemplateProps) {

  return (
    <Page>
      <OverlaySidebar/>
      {children}
    </Page>
  )
}

export default PageTemplateMain;